import { render, staticRenderFns } from "./Feat.vue?vue&type=template&id=5118330e&"
import script from "./Feat.vue?vue&type=script&lang=js&"
export * from "./Feat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports